import { render, staticRenderFns } from "./CopyrightAmendmentDetails.vue?vue&type=template&id=e535354a&scoped=true&"
import script from "./CopyrightAmendmentDetails.vue?vue&type=script&lang=js&"
export * from "./CopyrightAmendmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAmendmentDetails.vue?vue&type=style&index=0&id=e535354a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e535354a",
  null
  
)

export default component.exports